import * as deepmerge from "deepmerge";

const _default = {
	black: "black",
	white: "white",
	red: "red",
	green: "green",
	blue: "blue",
	checkedBlack: "#000000",
	checkedGreen: "#008800",
	checkedBlue: "#215EBD",
	attachments: {
		icon: {
			color: "black"
		},
		selectedIcon: {
			color: "white"
		}
	},
	contentPanel: {
		bgColor: "#ffffff",
		homeBgColor: "#ffffff",
	},
	placeholder: {
		color: "#eeeeee",
		bgColor: "#ffffff"
	},
	placeholderStartProcedure: {
		iconName: "arrow-circle-up",
		color: "#eeeeee",
		fontSize:64
	},
	placeholderEndProcedure: {
		iconName: "thumbs-up",
		color: "#eeeeee",
		fontSize: 64
	},
	section: {
		backgroundColor: "#888888",
		color: "white",
		borderRadius: "5px",
		overflow: "hidden"
	},
	list: {
		backgroundColor: "#444444",
		color: "white",
		borderRadius: "5px",
		overflow:"hidden"
	},
	item: {
		color: "black",
		disabledColor: "lightgray",
		selectedColor: "green",
		selectedDisabledColor: "#f8f8f8",
		selectedDisabledColorFocusedMode: "lightgray",
		base: {
			borderRadius: "15px",
			color:"black"
		},
		labelOnly: {
			backgroundColor: "#FFF8C6"
		},
		checked: {
			color: "green"
		},
		comments: {
			color: "#F9A200"
		},
		notes: {
			color: "#0000F9"
		},
		sketchPadImage: {
			color: "darkgreen"
		},
		media: {
			color: "purple"
		},
		yesNo: {
			yesButton: {
				selectedBorderColor: "darkgreen",
				selectedColor: "darkgreen",
				color: "darkgreen",
				disabledOpacity: .3,
				fontWeight:"bold"
			},
			noButton: {
				selectedBorderColor: "darkred",
				selectedColor: "darkred",
				color: "darkred",
				disabledOpacity: .3,
				fontWeight: "bold"
			},
			naButton: {
				selectedBorderColor: "darkblue",
				selectedColor: "darkblue",
				color: "darkblue",
				disabledOpacity: .3,
				fontWeight: "bold"
			}
		},
		textInput: {
			marginBottom:15,
			marginTop: 5,
			padding: 5,
			borderRadius: 5,
			borderStyle: "solid",
			borderColor: "#dddddd",
			backgroundColor: "white",
			color: "black"
		},
		textInputMultiline: {
			marginBottom: 15,
			height: 100,
			padding: 5,
			borderRadius: 5,
			borderStyle: "solid",
			borderColor:"#dddddd",
			backgroundColor: "white",
			color: "black"
		},
		linkColor: "blue",
		barcodeScanner: {
			textInput: {
				color: "black",
				backgroundColor: "white",
				padding: 3, borderColor: 'gray', marginTop: 5
			}
		},
		sketchPad: {
			backgroundColor: "white",
			color: "gray",
			borderStyle: "dashed",
			borderColor: "gray",
			borderWidth: 3
		},
		picker: {
			basic: {
				backgroundColor:"white"
			},
			buttons: {
				backgroundColor: "transparent",
				color: "blue",
				fontWeight:"bold",
				selectedBorderColor:"blue"
			},
		},
		choice: {
			checkbox: {
				backgroundColor: "white",
				borderColor: "black",
				borderWidth: 2,
				checkedIconName: "check",
				borderRadius: 5,
				borderStyle: "solid"
			},
			radio: {
				backgroundColor: "white",
				borderColor: "black",
				borderWidth: 2,
				checkedIconName: "circle",
				borderRadius: 20,
				borderStyle: "solid"
			},
			text: {
				color: "black"
			}
		},
		check: {
			backgroundColor: "white",
			borderColor: "black",
			borderWidth: 2,
			checkedIconName: "check",
			borderRadius: 5,
			borderStyle: "solid"
		},
		datePicker: {
			backgroundColor: "white",
			color: "black"
		},
		mediaPicker: {
			button: {
				color: "blue",
				fontWeight:"bold"
			},
			imagePlaceholder: {
				width: 100, height: 100, borderStyle: "dashed", borderWidth: 1, borderColor: "gray" 
			}
		},
		addressSearch: {
			panel: {
				backgroundColor: "white",
				padding:10
			},
			text: {
				color: "black",
				fontWeight: "bold"
			}
		},
		buttonOk: {
			underlayColor: "lightgray",
			height: 40,
			marginTop: 10,
			borderStyle: "solid",
			borderWidth: 1,
			borderColor: "lightgray",
			borderRadius: 5,
			backgroundColor: "white",
			fontWeight: "bold",
			color: "royalblue",
			fontSize: 16,
			fontFamily:"'Roboto', sans-serif"
		},
		ranking: {
			panel: {},
			dialogs: {
				editFullscreen: {
					wrapper: { backgroundColor: "white" },
					header: {
						height: 70, borderBottomWidth: 1, borderBottomColor: "lightgray", padding: 10
					},
					footer: {
						borderTopWidth: 1, borderTopColor: "lightgray", padding: 10, paddingLeft: 0
					}
				},
				insertItem: {
					wrapper: { backgroundColor: "white" },
					header: {
						height: 70, borderBottomWidth: 1, borderBottomColor: "lightgray", padding: 10
					},
					footer: {
						borderTopWidth: 1, borderTopColor: "lightgray", padding: 10, paddingLeft: 0
					}
				}
			},
			buttons: {
				edit: { display: "flex", width: 100, backgroundColor: "skyblue", height: 40, borderRadius: 5, justifyContent: "center", alignItems: "center", flexDirection: "row", borderWidth: 1, borderColor: "lightgray", borderStyle: "solid" },
				editText: { color: "white", fontSize: 16, fontWeight: "bold" },
				editFullscreen: { display: "flex", width: 100, backgroundColor: "skyblue", height: 40, borderRadius: 5, justifyContent: "center", alignItems: "center", flexDirection: "row", borderWidth: 1, borderColor: "lightgray", borderStyle: "solid" },
				editFullscreenText: { color: "white", fontSize: 16, fontWeight: "bold" },
				editFullscreenDone: { display: "flex", backgroundColor: "skyblue", height: 40, borderRadius: 5, width: 100, flexDirection: "row", justifyContent: "center", alignItems: "center", borderWidth: 1, borderColor: "lightgray", borderStyle: "solid" },
				editFullscreenDoneText: { color: "white", fontWeight: "bold", fontSize: 16 },
				insertDone: { display: "flex", backgroundColor: "skyblue", height: 40, borderRadius: 5, width: 100, flexDirection: "row", justifyContent: "center", alignItems: "center", borderWidth: 1, borderColor: "lightgray", borderStyle: "solid" },
				insertDoneText: { color: "white", fontWeight: "bold", fontSize: 16 },
				insertCancel: { display: "flex", backgroundColor: "red", height: 40, borderRadius: 5, width: 100, flexDirection: "row", justifyContent: "center", alignItems: "center", borderWidth: 1, borderColor: "lightgray", borderStyle: "solid" },
				insertCancelText: { color: "white", fontWeight: "bold", fontSize: 16 },
				doneEditing: { display: "flex", width: 100, backgroundColor: "skyblue", height: 40, borderRadius: 5, justifyContent: "center", alignItems: "center", flexDirection: "row", borderWidth: 1, borderColor: "lightgray", borderStyle: "solid" },
				doneEditingText: { color: "white", fontSize: 16, fontWeight: "bold" }
			},
			placeholder: {
				icons: {
					default: "plus",
					hover:"plus-circle"
				},
				panel: {
					display: "flex",
					width: "100%",
					borderWidth: 1,
					borderStyle: "dashed",
					borderRadius: 10,
					height: 50,
					backgroundColor: "white",
					alignItems: "center",
					justifyContent: 'center',
					marginBottom: 10,
					padding: 10
				},
				text: {
					fontWeight: 'bold',
					color: 'black',
					fontSize: 18
				}
			},
			item: {
				panel: {
					display: "flex",
					minHeight: 50,
					borderRadius: 10,
					backgroundColor: "rgb(211, 211, 211)",

					justifyContent: 'center',
					marginBottom: 10,
					padding: 10
				},
				text: {
					color: 'black',
					fontSize: 14
				},
				panelDragging: {
					display: "flex",
					minHeight: 50,
					borderRadius: 10,
					backgroundColor: "rgba(211, 211, 211, .8)",

					justifyContent: 'center',
					marginBottom: 10,
					elevation: 4,
					shadowOffset: { width: 2, height: 2 },
					shadowColor: "grey",
					shadowOpacity: 0.3,
					shadowRadius: 5,
					padding: 10
				},
				panelDraggingText: {
					color: 'black',
					fontSize: 14
				},
				panelSelectableForInsert: {
					display: "flex",
					minHeight: 50,
					borderRadius: 10,
					backgroundColor: "rgb(211, 211, 211)",

					justifyContent: 'center',
					marginBottom: 10,
					padding: 10
				},
				panelSelectableForInsertText: {
					color: "black",
					fontSize: 14
				},
				panelSelectableForInsertSelected: {
					display: "flex",
					minHeight: 50,
					borderRadius: 10,

					justifyContent: 'center',
					marginBottom: 10,
					backgroundColor: "skyblue",
					color: "white",
					padding: 10
				},
				panelSelectableForInsertSelectedText: {
					color: "white",
					fontSize: 14
				}
			}
		}
	},
	itemSimple: {
		bgColor: "#f4f4f4",
		labelOnlyBgColor: "#FFF8C6",
		selectedColor: "green",
		selectedDisabledColor: "#ffffff"
	},
	home: {
		footer: {
			color: "#666666"
		}
	},
	modal: {
		content: {
			bgColor: "#ffffff"
		}
	},
	comments: {
		sketchPad: {
			container: {
				bgColor: "lightgray"
			},
			canvas: {
				bgColor: "white",
				penColor: "blue"
			}
		}
	},
	nav: {
		bgColor: "#ffffff",
		profile: {
			bgColor: "#B2DBFF",
			color: "black",
			borderBottomColor: "#4C9DE5",
			buttonTxtColor: "white"
		},
		item: {
			color: "black",
			disabledColor: "gray",
			selectedColor: "blue"
		},
		section: {
			color: "#121212",
			iconColor: "#121212"
		},
		picker: {
			title: {
				color: "#4681b9"
			},
			item: {
				color: "black",
				iconColor: "#121212"
			}
		},
		learnMore: {
			color: "blue"
		},
		hr: {
			color: "#eeeeee",
			bgColor: "#cccccc"
		}
	},
	checkbar: {
		check: {
			color: "darkgreen",
			bgColor: "#eeffee"
		},
		skip: {
			color: "darkblue",
			bgColor: "#eeeeff"
		},
		locateItem: {
			color: "#000000",
			bgColor: "#eeeeee"
		},
		listen: {
			color: "green",
			disabledColor: "#168e8c",
			bgColor: "#e5f9f9"
		},
		emergency: {
			color: "#cc0000",
			bgColor: "#ffcccc"
		},
		switchShowMode: {
			bgColor: "rgb(40,40,40)",
			color: "lightgray"
		}
	}
};

const nightMode = deepmerge.all([_default, {
	black: "black",
	white: "white",
	red: "red",
	green: "green",
	blue: "blue",
	checkedBlack: "#000000",
	checkedGreen: "#008800",
	checkedBlue: "#215EBD",
	contentPanel: {
		bgColor: "#000000",
		homeBgColor: "#444444"
	},
	placeholder: {
		color: "#222222",
		bgColor: "#000000"
	},
	item: {
		color: "white",
		disabledColor: "#222222",
		selectedColor: "#FF962A",
		selectedDisabledColor: "#333333",
		comments: {
			color: "#F9A200"
		},
		notes: {
			color: "#0000F9"
		},
		sketchPadImage: {
			color: "darkgreen"
		},
		media: {
			color: "purple"
		}
	},
	itemSimple: {
		bgColor: "#616161",
		labelOnlyBgColor: "#66634f",
		selectedColor: "#008800",
		selectedDisabledColor: "#000000"
	},
	home: {
		footer: {
			color: "#666666"
		}
	},
	modal: {
		content: {
			bgColor: "lightgray"
		}
	},
	comments: {
		sketchPad: {
			container: {
				bgColor: "lightgray"
			},
			canvas: {
				bgColor: "black",
				penColor: "yellow"
			}
		}
	},
	nav: {
		bgColor: "#888888",
		profile: {
			bgColor: "#4C9DE5",
			color: "white",
			borderBottomColor: "#B2DBFF",
			buttonTxtColor: "black"
		},
		item: {
			color: "black",
			disabledColor: "#444444",
			selectedColor: "blue"
		},
		section: {
			color: "#121212",
			iconColor: "#121212"
		},
		picker: {
			title: {
				color: "#7da6ce"
			},
			item: {
				color: "black",
				iconColor: "#121212"
			}
		},
		learnMore: {
			color: "blue"
		},
		hr: {
			color: "#eeeeee",
			bgColor: "#444444"
		}
	},
	checkbar: {
		check: {
			color: "darkgreen",
			bgColor: "#beccbe"
		},
		skip: {
			color: "darkblue",
			bgColor: "#bebecc"
		},
		locateItem: {
			color: "#000000",
			bgColor: "#bebebe"
		},
		listen: {
			color: "green",
			disabledColor: "#168e8c",
			bgColor: "#b7c7c7"
		},
		emergency: {
			color: "#cc0000",
			bgColor: "#cca3a3"
		},
		switchShowMode: {
			bgColor: "rgb(40,40,40)",
			color: "lightgray"
		}
	}
}]);

export default {
	default: _default,
	nightMode
};